import {Card, CardBody, Col, Input, ListGroup, Row} from "reactstrap";
import {Search} from "react-feather";
import React, {useContext, useEffect, useRef, useState} from "react";
import axiosConfig from "../../../../Config/axios";
import Loader from "../../../../Layout/Loader";
import AuthorizationContext from "../../../../_helper/Authorization";
import type {Permission, PermissionWithToggle} from "../Types/PermissionTypes";
import type {AuthorizationContextType} from "../../../../_helper/Authorization/AuthorizationTypes";

interface RolePermissionListViewComponentProps {
    roleID: number|undefined;
}

const RolePermissionListView: React.FC<RolePermissionListViewComponentProps> = ({roleID}) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const [permissions, setPermissions] = useState<PermissionWithToggle[]>([]);
    const [currentRolePermissions, setCurrentRolePermissions] = useState<Permission[]>([]);
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
    const searchTimeoutRef = useRef<number | null>(null);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    useEffect(() => {
        getCurrentRolePermissions();
    }, [roleID, debouncedSearchTerm])

    useEffect(() => {
        if (searchTimeoutRef.current !== null) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = window.setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 1000);
        return () => {
            if (searchTimeoutRef.current !== null) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, [searchTerm]);

    useEffect(() => {
        getPermissions(currentRolePermissions, debouncedSearchTerm);
    }, [currentRolePermissions, debouncedSearchTerm]);

    const getPermissions = (rolePermissions: Permission[], name?: string) => {
        setLoaderVisibility(true);
        axiosConfig
            .get(`/privilege/permission`, {params: {name: name || undefined}})
            .then(response => {
                if (response?.data?.data?.data) {
                    setPermissionIsOn(response.data.data.data, rolePermissions)
                }
                setLoaderVisibility(false);
            })
            .catch(exception => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }

    const setPermissionIsOn = (permissionsList: Permission[], rolePermissionsList: Permission[]) => {
        const permissionsData = permissionsList.map(role => ({
            ...role, isOn: !!rolePermissionsList.find((currentRole) => currentRole.id === role.id)
        }));
        setPermissions(permissionsData);
    }

    const getCurrentRolePermissions = () => {
        setLoaderVisibility(true);
        axiosConfig
            .get(`/privilege/permission`, {params: {role_id: roleID, name: debouncedSearchTerm}})
            .then(response => {
                if (response?.data?.data?.data) {
                    setCurrentRolePermissions(response.data.data.data);
                }
                setLoaderVisibility(false);
            })
            .catch(exception => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }

    const handleToggle = (permissionId: number, event: React.ChangeEvent<HTMLInputElement>) => {
        axiosConfig
            .get(`privilege/role/${permissionId}/permission`, {
                params: {
                    'role_id': roleID,
                    'type': event?.target?.checked ? 'attach' : 'detach'
                }
            })
            .then(response => {
                if (response?.data?.data) {
                    setPermissionIsOn(permissions, response?.data?.data)
                }
                setLoaderVisibility(false);
            })
            .catch(exception => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    };

    return (
        <div>
            <Loader visibility={loaderVisibility}/>
            <CardBody>
                <div className="job-filter">
                    <div className="faq-form">
                        <Input className="form-control" type="text" placeholder="Search.."
                               value={searchTerm}
                               onChange={(event) => setSearchTerm(event.target.value)}/>
                        <Search className="search-icon"/>
                        <div className="categories">
                            <ListGroup>
                                <Row>
                                    {permissions.map((permission, key) => (
                                        <Col sm="4" key={key}>
                                            <Card>
                                                <CardBody style={{height: '150px'}}
                                                          className="shadow-lg p-25 shadow-showcase text-center">
                                                    <h6>
                                                        {permission.display_name}
                                                    </h6>
                                                    <label className="switch form-label">
                                                        <input type="checkbox"
                                                               checked={permission.isOn || false}
                                                               onChange={(event) => handleToggle(permission.id, event)}/>
                                                        <span className="switch-state"></span>
                                                    </label>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </ListGroup>
                        </div>
                    </div>
                </div>
            </CardBody>
        </div>
    );

}
export default RolePermissionListView;